var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecalculateLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.61 19C17.0346 19 19.0002 17.0344 19.0002 14.6097C19.0002 12.1851 17.0346 10.2195 14.61 10.2195C12.1853 10.2195 10.2197 12.1851 10.2197 14.6097C10.2197 17.0344 12.1853 19 14.61 19Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6638 12.6342L16.0655 13.1478C16.2968 13.4433 16.2542 13.532 15.882 13.532H13.5564C12.9146 13.532 12.854 13.8691 12.854 14.4302M13.5564 16.5854L13.1547 16.0717C12.9238 15.7763 12.966 15.6871 13.3382 15.6871H15.6638C16.3052 15.6871 16.3662 15.3504 16.3662 14.7893",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90244 16.8049H4C2.34315 16.8049 1 15.4617 1 13.8049V4C1 2.34315 2.34315 1 4 1H13.8049C15.4617 1 16.8049 2.34315 16.8049 4V8.90244",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1582 3.19507V7.12212",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12207 5.15869L3.19502 5.15869",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57617 11.1499L3.79933 13.9267",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57617 13.9268L3.79933 11.1499",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1709 4.95728L10.2438 4.95728",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecalculateLayoutIcon);
export default __webpack_public_path__ + "static/media/recalculate-layout-icon.02133e5881540e1747627aac721e2d02.svg";
export { ForwardRef as ReactComponent };